var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{staticClass:"my-0",staticStyle:{"min-height":"38px"},attrs:{"dense":""}},[_c('v-col',{staticClass:"text-body-2 text-break",attrs:{"cols":"4","align-self":"center","align":"right"}},[_vm._t("name")],2),_c('v-col',{attrs:{"cols":"8","align-self":"center"}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }